import React, { Component } from 'react';
import equal from 'deep-equal';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  FlatButton,
  Dialog,
} from 'material-ui';
import { translate, UPDATE, showNotification as showNotificationAction } from 'admin-on-rest';

import PriceInput from '../../components/inputs/PriceInput';
import { getTranslationByLocale } from '../../utils/TranslationUtils';
import { formatPrice } from '../../utils/NumberUtils';
import { kunal } from '../../client';
import kunalClient from '../../client/kunalClient';
import ErrorDialog from '../ErrorDialog';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const styles = {
  warningColor: {
    backgroundColor: 'rgba(219, 141, 141, 0.4)',
  },
  dialog: {},
};

const PriceDialog = ({ open, choice, priceValue, min, max, productIndex, market, toggle, change, showNotification, openError, errorOpen, err }) => {
  if (!choice || productIndex === -1 || productIndex === undefined) {
    return null;
  }

  const handleSubmit = (e) => {
    const { ...data } = choice;
    restClient(UPDATE, 'venues', { id: choice.name, data })
      .then(() => {
        showNotification('Venue price updated');
        toggle();
      })
      .catch((error) => {
        console.error(error);
        showNotification(<span>Something went wrong, <FlatButton label="Send report" onClick={() => openError(error)} /></span>, 'warning');
      });
    e.preventDefault();
  };

  const actions = [
    <FlatButton
      label="Cancel"
      primary
      onClick={toggle}
    />,
    <FlatButton
      label="Submit"
      primary
      disabled={!priceValue || priceValue < min || priceValue > max}
      onClick={(e) => handleSubmit(e)}
    />,
  ];
  return (
    <Dialog
      title="Venue product price edit"
      actions={actions}
      modal
      contentStyle={styles.dialog}
      open={open}
    >
      <h4>Changes here are applied immediately when submit is pressed!</h4>
      <form onSubmit={(e) => handleSubmit(e)}>
        <PriceInput
          label="price"
          onChange={change}
          input={{ onChange: change }}
          precision={market.currencyPrecision}
          currencyCode={market.currencyCode}
          errorText={
            priceValue !== '' &&
              (priceValue < min || priceValue > max)
              ?
              translate('valueNotInRange')
              :
              `${formatPrice(min, market.currencyPrecision, market.currencyCode)} - ${formatPrice(max, market.currencyPrecision, market.currencyCode)}`
          }
          errorStyle={
            priceValue !== '' &&
              (priceValue < min || priceValue > max)
              ?
              { color: 'rgb(183, 28, 28)' }
              :
              { color: 'darkslategrey' }
          }
        />
      </form>
      <ErrorDialog open={errorOpen} error={err} fn={openError} />
    </Dialog>
  );
};

export class ProductPriceManagement extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      openError: false,
      choice: {},
    };
  }

  shouldComponentUpdate = (nextProps, nextState) => (!equal(this.props, nextProps) || !equal(this.state, nextState));

  onChange = (value) => {
    const { choice, productIndex } = this.state;
    const newChoice = { ...choice };
    newChoice.products[productIndex].price = value;
    this.setState({ choice: newChoice, priceValue: value });
  }

  editPrice = (choice, productIndex, market, min, max) => this.setState({ open: !this.state.open, choice, productIndex, market, min, max });

  openError = (err) => this.setState({ errorOpen: !this.state.errorOpen, err });

  render() {
    const { choices: { venues }, record, locale, showNotification } = this.props;

    return (
      record && record.markets ?
        <div>
          <Table fixedHeader selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn colSpan="4" style={{ textAlign: 'right' }}>
                Markets: {record && record.markets && record.markets.reduce((sum, value) => (sum.concat([`${value.countryCode}: ${value.suggestedPrice || '?'}  `])), [])}
                </TableHeaderColumn>
              </TableRow>
              <TableRow>
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>Market</TableHeaderColumn>
                <TableHeaderColumn>Suggested Price</TableHeaderColumn>
                <TableHeaderColumn>Price</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody showRowHover displayRowCheckbox={false}>
              {venues.length > 0 && venues.map((choice) => {
                if (!choice || !choice.market) return null;
                const market = record && record.markets && record.markets.length && choice.market ? record.markets.find((mrkt) => mrkt.countryCode === choice.market.countryCode) : undefined;
                const suggestedPrice = market ? market.suggestedPrice : undefined;
                const productIndex = choice.products.findIndex((prdct) => prdct.product === record.code);
                const product = choice.products[productIndex];
                const price = product ? product.price : undefined;
                const difference = suggestedPrice && price ? suggestedPrice - price : undefined;
                const percentDiff = suggestedPrice && price ? Math.round(Math.abs(((price / suggestedPrice) * 100) - 100)) : undefined;

                return (
                  <TableRow key={choice.id}>
                    <TableRowColumn>{getTranslationByLocale(choice.title, locale) || choice.name}</TableRowColumn>
                    <TableRowColumn>{choice && choice.market && choice.market.countryCode}</TableRowColumn>
                    <TableRowColumn>
                      {formatPrice(
                        suggestedPrice || (choice.products && choice.products[productIndex] ? choice.products[productIndex].price : 0),
                        choice.market.currencyPrecision,
                        choice.market && choice.market.currencyCode
                      )}
                    </TableRowColumn>
                    <TableRowColumn style={percentDiff > 15 ? styles.warningColor : {}}>
                      <FlatButton
                        primary={price}
                        label={
                          <span>
                            {formatPrice(
                              price || suggestedPrice,
                              choice.market.currencyPrecision,
                              choice.market && choice.market.currencyCode,
                            )}
                            ({difference > 0 ? '-' : '+'}{percentDiff || '?'}%)
                          </span>
                        }
                        onClick={() => this.editPrice(choice, productIndex, choice.market, market.minPrice, market.maxPrice)}
                      />
                    </TableRowColumn>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <PriceDialog
            {...this.state}
            toggle={() => this.editPrice()}
            change={(value) => this.onChange(value)}
            showNotification={showNotification}
            openError={this.openError}
          />
        </div>
        : <h2 style={{ textAlign: 'center' }}>Only available on saved products</h2>
    );
  }
}

ProductPriceManagement.defaultProps = {
  choices: { venues: [] },
};

const enhance = compose(
  translate
);

export default connect((state) => state, { showNotification: showNotificationAction })(enhance(ProductPriceManagement));
